export enum OrigemLancamento {
  Caixa = 0,
  Banco = 1
}

export const OrigemLancamentoNomeMap = new Map<OrigemLancamento, string>([
  [OrigemLancamento.Caixa, 'Caixa'],
  [OrigemLancamento.Banco, 'Banco']
]);